module.exports = __webpack_public_path__ + "static/media/move-up.735b44e0.svg";